import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`w100 mt40`)
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18",
  style: {}
}, "外部カレンダーに登録するイベントの公開設定", -1)
const _hoisted_3 = {
  key: 0,
  class: "ml3"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: `is_private_`,
  class: "fs13 pointer ml7"
}, " 非公開で登録", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_ctx.showContent)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        (_ctx.rcm.room_setting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_CheckboxTag, {
                value: ``,
                name: `is_private`,
                checked: _ctx.rcm.room_setting.is_private,
                prefix: `is_private`,
                onClickCheckbox: _ctx.clickRegisterCalPrivate,
                style: {"margin-left":"1px"}
              }, null, 8, ["checked", "onClickCheckbox"]),
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        _hoisted_5
      ]))
    : _createCommentVNode("", true)
}